import { DialogActions, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { UButton } from "../common/ui.buttons";
import { useGood } from "./good";
import { MAIN_COLOR } from "../style/theme";
import { UDialog, UDialogCloseOnCompleteButton } from "../common/ui.dialog";

export const RP_COLOR = "#F4C92F";

export function RP(rpops) {
    return <Typography sx={{
        backgroundColor: RP_COLOR,
        color: MAIN_COLOR,
        fontSize: 12 + 'px !important',
        fontWeight: 600,
        paddingX: 2,
    }}>{rpops.value || rpops.children}PR</Typography>
}

export function CPayButton(rpops) {
    const { type, unitId, params, payProps, disabled, onComplete, ...rest } = rpops;
    const good = useGood(type, unitId);
    var rp = good.rp || 0;
    const styleRp = {
        border: '2px solid ' + RP_COLOR,
        borderRadius: 1,
    }
    const currStyle = rp > 0 ? styleRp : {}
    const icon = rp > 0 && <RP>{rp}</RP>

    return <UDialog disabled={disabled || rp < 0} button={<UButton
        fullWidth
        variant="contained"
        loading={good.loading}
        endIcon={icon}
        disabled={disabled || rp < 0}
        {...rest}
        sx={{
            ...currStyle,
            ...rest.sx,
        }} >{good.name || 'Loading..'}</UButton>}>
        <DialogTitle>{good.name}</DialogTitle>
        <DialogContent>
            <Stack>
                <Typography sx={{ whiteSpace: 'pre-wrap', }}>
                    {good.description}
                </Typography>
                {rest.children}
            </Stack>
        </DialogContent>
        <DialogActions>
            <UDialogCloseOnCompleteButton
                {...payProps}
                payload={{ params: params || [] }}
                call={'transaction/good/' + type + '/buy' + (unitId ? '?unitId=' + unitId : '')}
                onComplete={onComplete}
                endIcon={<RP value={rp} />}
                variant="contained"
                sx={{ paddingX: 4, ...styleRp }}>
                Acquista
            </UDialogCloseOnCompleteButton>
        </DialogActions>
    </UDialog>

}